import CustomInstructionsResponsePlugin from "../../customPlugin/customInstructions";
import { instructionPage } from "../../lib/utils";

const CELEBRATE_AUDIO = "assets/audio/CG01_10_Celebrate_V1.wav";

/**
 * Displays the mission feedback screen as an instructions trial
 * @param {string} image The image to display
 * @param {Object} [overlayOptions] Optional overlay configuration (overlayLeftPercent, overlayTopPercent, overlayNavText, showBackKey, showForwardKey)
 */
export function buildAchievementsTrial(image, overlayOptions = {}) {
  const {
    overlayLeftPercent = 51.5,
    overlayTopPercent = 97,
    overlayNavText = '[ press "__FORWARD_KEY__" to continue ] ',
    showBackKey = false,
    showForwardKey = true,
    overlayTextSizeVw = 1.1,
  } = overlayOptions;

  return {
    type: CustomInstructionsResponsePlugin,
    data: { name: "achievements" },
    pages: [instructionPage(image, CELEBRATE_AUDIO, {
      overlayLeftPercent,
      overlayTopPercent,
      showBackKey,
      showForwardKey,
      overlayTextSizeVw,
    })],
    key_forward: "Slash",
    key_backward: "KeyZ",
    show_overlay_nav_text: true,
    overlay_nav_text: overlayNavText,
  };
}
